var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCraneHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29437",
    "data-name": "Group 29437",
    transform: "translate(-87 -582.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(87 582.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_11_",
    "data-name": "svgexport-17 (11)",
    transform: "translate(103 589.129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50484",
    "data-name": "Path 50484",
    d: "M19.253,15.868v1.116a1.427,1.427,0,1,0,1.786,1.38.357.357,0,0,0-.714,0,.714.714,0,1,1-.713-.714.357.357,0,0,0,.356-.357V15.869ZM18.4.563,2.36,7.339,2.636,8,18.68,1.219Zm.85,1.4V13.015h.714V1.96Z",
    transform: "translate(0.001 -0.537)",
    fill: "#33658a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50485",
    "data-name": "Path 50485",
    d: "M17.446,1.69,12.1,7.752l.535.472L17.98,2.162Zm1,.829-2.853,7.843.671.243,2.853-7.843ZM3.793,7.886l-.682.2L4.18,11.656l.682-.2Zm-2.124.1v3.564h.714V7.989Z",
    transform: "translate(-0.239 -0.146)",
    fill: "#ff6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50486",
    "data-name": "Path 50486",
    d: "M2.462,11.655V13.8H14.227v-2.14Z",
    transform: "translate(0.037 3.319)",
    fill: "#e8ab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50487",
    "data-name": "Path 50487",
    d: "M10.593,6.1A1.12,1.12,0,0,0,9.525,7.128l.009-.044L8.889,9.665H1.679A1.075,1.075,0,0,0,.608,10.734v2.5A1.076,1.076,0,0,0,1.681,14.3H16.3a1.065,1.065,0,0,0,1.069-1.078V10.733a.357.357,0,0,0-.024-.132L15.916,7.035a2.082,2.082,0,0,0-.321-.59A.968.968,0,0,0,14.87,6.1Z",
    transform: "translate(-0.608 1.387)",
    fill: "#ffbc42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50488",
    "data-name": "Path 50488",
    d: "M8.785,7.157a.357.357,0,0,0-.345.265l-.571,2.14a.357.357,0,0,0,.345.447H9.857V7.157Zm1.784,0v5.1l.058.086a.357.357,0,0,0,.3.159h2.141a.357.357,0,0,0,.354-.356V10.724a.357.357,0,0,0-.027-.14L12.041,7.377a.357.357,0,0,0-.329-.22Z",
    transform: "translate(1.912 1.755)",
    fill: "#33b9ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50489",
    "data-name": "Path 50489",
    d: "M2.02,9.8a.357.357,0,0,0-.353.36v1.071a.357.357,0,0,0,.714,0V10.16A.357.357,0,0,0,2.02,9.8Zm1.423,0a.357.357,0,0,0-.35.36v1.071a.357.357,0,0,0,.714,0V10.16a.357.357,0,0,0-.364-.36Zm1.427,0a.357.357,0,0,0-.35.36v1.071a.357.357,0,0,0,.714,0V10.16A.357.357,0,0,0,4.87,9.8Z",
    transform: "translate(-0.24 2.674)",
    fill: "#e8ab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50490",
    "data-name": "Path 50490",
    d: "M15.092,12.665a.357.357,0,0,0-.332.226l-.714,1.782a.357.357,0,0,0-.005.245l.356,1.069a.357.357,0,0,0,.34.244h2.137a.357.357,0,0,0,.34-.244l.354-1.069a.357.357,0,0,0-.005-.245l-.713-1.782a.357.357,0,0,0-.332-.226ZM14.736.544a1.425,1.425,0,1,0,1.424,1.423A1.43,1.43,0,0,0,14.736.544Z",
    transform: "translate(3.807 -0.544)",
    fill: "#ffbc42"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28984",
    "data-name": "Group 28984",
    transform: "translate(13.993 3.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50491",
    "data-name": "Path 50491",
    d: "M12.514,2.925v.713h2.14V2.924Z",
    transform: "translate(-10.462 -2.924)",
    fill: "#ff6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50492",
    "data-name": "Path 50492",
    d: "M12.888,3.042l-.593.395,1.424,2.14.6-.395Z",
    transform: "translate(-10.538 -2.883)",
    fill: "#ff6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50493",
    "data-name": "Path 50493",
    d: "M11.192,4.512v.712H14.4V4.512Z",
    transform: "translate(-10.921 -2.372)",
    fill: "#ff6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50494",
    "data-name": "Path 50494",
    d: "M11.533,4.6l-.542.464,2.14,2.5.542-.464Z",
    transform: "translate(-10.991 -2.34)",
    fill: "#ff6b6b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50495",
    "data-name": "Path 50495",
    d: "M2.738,5.57A1.069,1.069,0,1,0,3.809,6.64,1.075,1.075,0,0,0,2.738,5.57Z",
    transform: "translate(-0.239 1.203)",
    fill: "#ffbc42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50496",
    "data-name": "Path 50496",
    d: "M3.37,12.713a2.5,2.5,0,1,0,0,4.993H14.424a2.5,2.5,0,0,0,0-4.993Z",
    transform: "translate(-0.516 3.686)",
    fill: "#33658a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50497",
    "data-name": "Path 50497",
    d: "M13.16,13.772a1.07,1.07,0,1,0,1.067,1.069,1.075,1.075,0,0,0-1.067-1.069Zm-3.213,0a1.07,1.07,0,1,0,1.071,1.069,1.073,1.073,0,0,0-1.071-1.069Zm-3.207,0a1.07,1.07,0,1,0,1.07,1.069A1.073,1.073,0,0,0,6.739,13.772Zm-3.209,0A1.07,1.07,0,1,0,4.6,14.841a1.073,1.073,0,0,0-1.069-1.069Z",
    transform: "translate(0.037 4.055)",
    fill: "#dbe9ee"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraneHighlighted);
export default __webpack_public_path__ + "static/media/craneHighlighted.053472aea5b7498c3811363e65c06a63.svg";
export { ForwardRef as ReactComponent };